



























import axios from 'axios';
import NavBar from '@/Navbar';
import Footer from '@/Footer';
import FloatNav from '@/FloatNav';
import { Vue, Component } from 'vue-property-decorator';

// eslint-disable-next-line no-unused-vars
function transAxiosRequest() {
  const customizedObj = Vue.ls.get('customized');
  let customized = '';
  if (customizedObj) customized = customizedObj.id;
  axios.defaults.transformRequest = data => `${data}&customized=${customized}`;
}

@Component({
  components: {
    NavBar,
    Footer,
    FloatNav,
  },
})
export default class App extends Vue {
  show = true;

  refresh() {
    this.show = false;
    this.$nextTick(() => {
      this.show = true;
    });
    // transAxiosRequest();
  }

  // eslint-disable-next-line class-methods-use-this
  mounted() {
    // transAxiosRequest();
  }
}
